import React, { useEffect } from 'react';
import { Switch, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SecureRoute } from '@okta/okta-react';
import HomeBusinesses from '../components/HomeBusinesses';
import HomeBusinessDetails from '../components/HomeBusinessDetails';
import HomePayers from '../components/HomePayers';
import HomeCredits from '../components/HomeCredits';
import HomeCreditDetails from '../components/HomeCreditDetails';
import HomeReports from '../components/HomeReports';
import SectionNotAvailable from '../components/SectionNotAvailable';
import requireAuth from '../components/hoc/require_okta_auth';
import {
  BLOCK_LIST_SECTION_PERFORM,
  BUSINESS_SECTION_PERFORM,
  CREDITS_SECTION_PERFORM,
  USERS_SECTION_PERFORM,
  PAYERS_SECTION_PERFORM,
  AGREEMENTS_SECTION_PERFORM,
  FUNDS_SECTION_PERFORM,
  COLLECTION_SECTION_PERFORM,
  REPORTS_SECTION_PERFORM,
} from '../helpers/performsType';
import { changeCountry } from '../actions/configAction';
import HomeUsers from '../components/HomeUsers';
import HomeAgreements from '../components/HomeAgreements';
import HomePayerBlocklist from '../components/HomePayerBlocklist';
import FundBankAccounts from '../components/elements/FundBankAccounts';
import HomeCollection from '../collection/pages/HomeCollection';
import { FundsRoutes } from '../funds/adapters/routes';
import DetailCollection from '../collection/pages/CollectionsByPayer';

import { PaymentsDetails, PaymentsInbox } from '../payments/pages';
import ARInbox from '../AR/pages/Inbox';
import BankMovements from '../components/BankMovements';
import HomeOperationDetail from '../components/HomeOperationDetail';

const RoutesMX = () => {
  const { country: countryParams } = useParams();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const country = countryParams.toUpperCase();

  useEffect(() => {
    if (i18n.language !== country) {
      i18n.changeLanguage(country);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  dispatch(changeCountry(country));

  return (
    <Switch>
      {FundsRoutes('mx')}
      <SecureRoute
        exact
        path="/mx/direct_financing"
        component={requireAuth(ARInbox)}
      />
      <SecureRoute
        exact
        path="/mx/early_payment"
        component={requireAuth(ARInbox)}
      />
      <SecureRoute
        exact
        path="/mx/payments"
        component={requireAuth(PaymentsInbox)}
      />
      <SecureRoute
        exact
        path="/mx/payments/:id"
        component={requireAuth(PaymentsDetails)}
      />
      <SecureRoute
        exact
        path="/mx/orders/:id"
        component={requireAuth(HomeOperationDetail)}
      />
      <SecureRoute
        exact
        path="/mx/business"
        component={requireAuth(HomeBusinesses, BUSINESS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/business/:id"
        component={requireAuth(HomeBusinessDetails, BUSINESS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/payers"
        component={requireAuth(HomePayers, PAYERS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/credits"
        component={requireAuth(HomeCredits, CREDITS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/credits/:id"
        component={requireAuth(HomeCreditDetails, CREDITS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/payerblocklist"
        component={requireAuth(HomePayerBlocklist, BLOCK_LIST_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/users"
        component={requireAuth(HomeUsers, USERS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/agreements"
        component={requireAuth(HomeAgreements, AGREEMENTS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/funds/:id/bank-accounts"
        component={requireAuth(FundBankAccounts, FUNDS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/collection"
        component={requireAuth(HomeCollection, COLLECTION_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/collection/:id"
        component={requireAuth(DetailCollection, COLLECTION_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/reports"
        component={requireAuth(HomeReports, REPORTS_SECTION_PERFORM)}
      />
      <SecureRoute
        exact
        path="/mx/bank-movements"
        component={requireAuth(BankMovements)}
      />
      <SecureRoute component={requireAuth(SectionNotAvailable)} />
    </Switch>
  );
};
export default RoutesMX;
